import React, { FC } from "react";

export interface CardZoneProps {
  className?: string;
  title: string;
  selected: number;
  openModal: Function;
}

const CardZone: FC<CardZoneProps> = ({
  className = "",
  title,
  selected,
  openModal
}) => {
  return (
    <div
      className={`nc-CardAuthorBox relative flex flex-col items-center justify-center text-center px-3 py-5 sm:px-6 sm:py-7  [ nc-box-has-hover ] [ nc-dark-box-bg-has-hover ] ${className}`}
      data-nc-id="CardAuthorBox"
      onClick={()=>openModal()}
    >
      <div className="mt-3">
        <h2 className={`text-base font-medium`}>
          <span className="line-clamp-1">{title}</span>
        </h2>
        <span
          className={`block mt-1.5 text-sm text-neutral-500 dark:text-neutral-400`}
        >
          Seleccionados:
        </span>
      </div>
        <span className="text-xs font-medium pt-[1px]">
          {selected}
        </span>
    </div>
  );
};

export default CardZone;
